import { Injectable } from '@angular/core';
import { CustomerUserReadMinDto } from './dto/customer-user-read-min.dto';
import { CustomerUserSearchDto } from './dto/customer-user-search.dto';
import { ApiService } from '../api/api.service';
import { PagedResultGeneric } from '../model';

@Injectable({
  providedIn: 'root',
})
export class PortalAuthService {
  constructor(private _apiService: ApiService) {}

  searchPortalUsers(search: CustomerUserSearchDto): Promise<PagedResultGeneric<CustomerUserReadMinDto>> {
    return this._apiService.getPaged('AuthorizedUsers', search);
  }
}
